import React from 'react'
import makeStyles from '@material-ui/core/styles/makeStyles'
import { hoverColor } from 'styles/variables'
import { Chip } from '@material-ui/core'

const useStyles = makeStyles({
  chip: {
    margin: '8px 4px 4px',
    background: hoverColor,
    textOverflow: 'ellipsis',
    maxWidth: '240px',
    '&:hover': {
      background: hoverColor
    }
  },
  chipDisabled: {
    background: '#dfdfdf'
  }
})

export function PrimaryChip ({ label, disabled, onClick, onDelete }) {
  const classes = useStyles()
  return (
    <Chip
      classes={{
        root: classes.chip,
        disabled: classes.chipDisabled
      }}
      onClick={onClick}
      onDelete={onDelete}
      label={label}
      disabled={disabled}
    />
  )
}
